var exports = {
  "k": "xa15a2ab7--50a737--container",
};

module.exports = exports;
